import { notification } from "antd";
import { useMutation } from "react-query";
import { isError } from "utils/api/models/api-response";
import { ReadAll } from "services/notifications/index";
import i18next from "i18next";

export default function ReadAllNotifications() {
  return {
    ...useMutation(ReadAll, {
      onSuccess: async (res) => {
        if (!isError(res)) {
          notification.open({
            message:
              i18next.language === "ar"
                ? "تم تمييز جميع الاشعارات كمقروءة"
                : "All notifications marked as read",
          });
        }
      },
    }),
  };
}
